import { faBug, faConstruction, faEnvelope, faPhone, faThLarge, faToolbox, IconDefinition } from '@fortawesome/pro-duotone-svg-icons';
import { Enum, EnumType } from 'ts-jenum';

@Enum<BrickCategory>('value')
export class BrickCategory extends EnumType<BrickCategory>() {
   static readonly GENERAL = new BrickCategory('General', 1, faToolbox, 'brick.categories.general');
   static readonly LAYOUT = new BrickCategory('Layout', 2, faThLarge, 'brick.categories.layout');
   static readonly CALLING = new BrickCategory('Calling', 3, faPhone, 'brick.categories.calling');
   static readonly MAILING = new BrickCategory('Mailing', 4, faEnvelope, 'brick.categories.mailing');
   static readonly BETA = new BrickCategory('Beta', 5, faConstruction, 'brick.categories.beta');
   static readonly DEBUG = new BrickCategory('Debug', 6, faBug, 'brick.categories.debug');

   private constructor(public value: string, public sortOrder: number, public categoryIcon: IconDefinition, public translationKey: string) {
      super();
   }
}
